import { memo } from 'react';

import useCategoryPromotion from '@Queries/useCategoryPromotion';
import LayoutMain from '@Layouts/LayoutMain';
import PageTopBar from '@Components/PageTopBar';
import ProductCard from '@Components/ProductCard';
import DynamicCatalog from '@Components/DynamicCatalog';
import Page404 from '@Pages/Page404';
import { useInfiniteCategory } from '@Queries/useInfiniteCategory';
import usePage from '@Queries/usePage';
import InfoBlocks from './elements/InfoBlocks';
import Page from '@Components/Page';
import CategoryBanner from '@Components/CategoryBanner';
import styles from './PageMebelDlyaHraneniyaConstructor.module.css';

import type { FC } from 'react';
import type { RenderProductParams } from '@Types/Catalog';
import type { PageMebelDlyaHraneniyaData } from './typings';

const PageMebelDlyaHraneniya: FC = () => {
  const { data } = usePage<PageMebelDlyaHraneniyaData>();
  const slug = 'promo-mebel-dlya-hranenia-konstruktor';
  const category = useInfiniteCategory({ slug });
  const [firstPage] = category.data?.pages || [];
  const promotion = useCategoryPromotion({ slug });
  const banner = promotion?.data?.materials[0];

  if (!category.data || !firstPage) return <Page404 />;
  if (firstPage.page > firstPage.pageTotalCount) return <Page404 />;

  const renderProduct = ({ product, onClickProductLink }: RenderProductParams) => {
    return (
      <ProductCard
        product={product}
        view={firstPage.isInSpotlight ? undefined : 'mini'}
        onClickProductLink={onClickProductLink}
        hasReadySolutions={product.readySolutions?.colors?.length > 0}
      />
    );
  };

  return (
    <LayoutMain>
      <Page>
        <PageTopBar
          breadcrumbs={data.breadcrumbs}
          banner={banner && <CategoryBanner banner={banner} />}
        />
        <div className={styles.wrapper} data-testid='promo-mebel-dlya-hranenia-konstruktor'>
          <InfoBlocks className={styles.infoBlocks} />
          {firstPage.productsTotalCount > 0 && (
            <DynamicCatalog
              className={styles.products}
              category={category}
              slug={slug}
              needPaginator
              renderProduct={renderProduct}
              pageData={{
                analyticsTitle: 'Посадочная мебель для хранения конструктор',
                breadcrumbs: [],
              }}
            />
          )}
        </div>
      </Page>
    </LayoutMain>
  );
};

export default memo(PageMebelDlyaHraneniya);
